export default __webpack_public_path__ + "static/media/Dubai-Bold.9070bbb0.woff";